module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "forgot-password"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h3', [_vm._v(_vm._s(_vm.message))])]), _vm._v(" "), _c('crowd-or-rais')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2eb5e76a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Profile/ConfirmAccount.vue
// module id = 792
// module chunks = 1